const Header = require('./header')

$(function() {
  Header()
})